<!-- History Events -->
@if (mode === 'parent') {
  @if (isLoadingHistoryEvents) {
    <div class="nz-spin-h mt-4 mb-4">
      <nz-spin [nzTip]="'Loading History...'"></nz-spin>
    </div>
  } @else {
    @if (historyEvents.length > 0) {
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th class="fs-12">Change Type</th>
            <th class="fs-12">ACR Number</th>
            <th class="fs-12">User</th>
            <th class="fs-12">Date</th>
            <th class="text-center fs-12">Actions</th>
          </tr>
          </thead>
          <tbody>
            @for (historyEvent of historyEvents; track historyEvent + '-' + $index) {
              <tr>
                <td>{{ historyEvent.ChangeType }}</td>
                <td>{{ historyEvent.AcrNumber }}</td>
                <td>{{ historyEvent.ChangedBy }}</td>
                <td>{{ historyEvent.insert_date | niceDate }}</td>
                <td class="text-center">
                  <button class="btn btn-outline-dark" (click)="onGetEventItems(historyEvent.ProcessId)">
                    <i class="fa fa-plus"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="form-group text-center mb-0">
        <ngb-pagination
          [collectionSize]="historyEventsCollectionSize"
          [page]="page"
          [pageSize]="pageSize"
          [directionLinks]="true"
          [rotate]="true"
          [disabled]="isLoadingHistoryEvents"
          [maxSize]="10"
          (pageChange)="onHistoryEventsPageChanged($event)"></ngb-pagination>
      </div>
    } @else {
      <div class="nz-spin-h mt-3 mb-3">
        <nz-alert nzType="info" nzMessage="No data available!" nzCloseable="true"></nz-alert>
      </div>
    }
  }
}

<!-- History Event Items -->
@if (mode === 'child') {
  <button class="btn btn-outline-dark" (click)="onGoBack()">
    <i class="fa fa-arrow-left"></i> Go Back
  </button>

  @if (isLoadingHistoryEventItems) {
    <div class="nz-spin-h mt-4 mb-4">
      <nz-spin [nzTip]="'Loading History...'"></nz-spin>
    </div>
  } @else {
    @if (historyEventItems.length > 0) {
      <div class="table-responsive mt-3">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>#</th>
            <th>{{ objectLabel }}</th>
            <th>Attribute</th>
            <th>Old Value</th>
            <th>New Value</th>
          </tr>
          </thead>
          <tbody>
            @for (historyEventItem of historyEventItems; track historyEventItem + '-' + $index; let i = $index) {
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ historyEventItem.MainObject }}</td>
                <td>{{ historyEventItem.ColumnName }}</td>
                <td>{{ historyEventItem.OldValue }}</td>
                <td>{{ historyEventItem.NewValue }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="form-group text-center mb-0">
        <ngb-pagination
          [collectionSize]="historyEventItemsCollectionSize"
          [page]="pageItems"
          [pageSize]="pageSizeItems"
          [directionLinks]="true"
          [rotate]="true"
          [disabled]="isLoadingHistoryEventItems"
          [maxSize]="10"
          (pageChange)="onHistoryEventItemsPageChanged($event)"></ngb-pagination>
      </div>
    } @else {
      <div class="mt-3">
        <nz-alert nzType="info" nzMessage="No data available!" nzCloseable="true"></nz-alert>
      </div>
    }
  }
}
